import { gql } from "@apollo/client";

export default gql`
  mutation removeWorker($id: ID!) {
    removeWorker(id: $id)
  }
`;
